import { gql } from 'apollo-angular';

export interface AveryCustomGenericCollection {
  averycustomgenericCollection: { name: string; body: string }[];
}

export const GetACGQuery = gql`
  query GetACG($query: String!) {
    averycustomgenericCollection(query: $query) {
      name
      body
    }
  }
`;
export const GetACGConfigQuery = gql`
  query GetACGConfigs($query: String!) {
    results: AveryCustomGenericConfigCollection(query: $query) {
      __typename
      id: name
      name
      acgs {
        __typename
        id: name
        name
        title
        urlTitle
        type
        body
      }
    }
  }
`;
